import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsShareService {

  private filterDataSource = new BehaviorSubject<any>(null);
  currentFilterData = this.filterDataSource.asObservable();

  // Method to update the filter data
  updateFilterData(data: any) {
    this.filterDataSource.next(data);
  }
  
}
